<div
  #maxWidthEl
  class="t-h-screen t-max-h-screen t-flex t-bg-surface-50 t-w-full"
>
  @if (userService.isAuthenticated()) {
    <div #appNav>
      <app-nav></app-nav>
    </div>
  }
  <div class="t-w-full t-flex t-flex-col t-min-h-0">
    <app-breadcrumb
      [ngClass]="{ 't-hidden': isInAuthModule() }"
    ></app-breadcrumb>
    <div
      class="router-outlet-wrapper"
      [ngClass]="{
        't-bg-white t-border t-border-surface-300 t-rounded-l-md t-mb-1.5 t-flex-1 t-min-h-0 t-flex t-flex-col t-overflow-hidden':
          !isInAuthModule(),
      }"
    >
      <router-outlet></router-outlet>
    </div>
  </div>
</div>

<p-toast></p-toast>
<p-confirmdialog></p-confirmdialog>
